import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import { FC } from "react";
import { useIntl } from "react-intl";
import { selectedIconSVG } from "../../../../assets/SVGs/SVGs";
import { getPaymentMethods } from "../../../../network/settings";

interface PaymentMethodProps {
  paymentMethod: number | null;
  setPaymentMethod: React.Dispatch<React.SetStateAction<number | null>>;
  isSelectedPaymentMethod: boolean;
  paymentUrl?: string;
}

const PaymentMethod: FC<PaymentMethodProps> = ({
  paymentMethod,
  setPaymentMethod,
  isSelectedPaymentMethod,
}) => {
  const intl = useIntl();

  const { data: paymentMethods, isLoading } = useQuery(
    ["paymentMethods"],
    getPaymentMethods,
    {
      select: (res) => res?.data,
    }
  );

  return (
    <div className="w-full p-2 my-3">
      <p className=" text-[#75757E] my-2">
        {intl.formatMessage({
          id: "payWith",
          defaultMessage: "الدفع من خلال",
        })}
      </p>
      <Spin spinning={isLoading}>
        {isSelectedPaymentMethod ? (
          <div>
            <div>
              <Button
                type="default"
                htmlType="button"
                className={
                  "   w-full  flex justify-center items-center gap-1 text-[#479821] border-[#479821]"
                }
              >
                <span className="mt-1">{selectedIconSVG}</span>

                <span className="capitalize">
                  {
                    paymentMethods?.find(
                      (method: { id: number; name: string }) =>
                        method?.id === paymentMethod
                    )?.name
                  }
                </span>
              </Button>
            </div>
            {/* {paymentMethod === "creditCard" ? (
              <div className="my-2 space-y-2 text-sm">
                <p className="text-gray-400">
                  {intl.formatMessage({
                    id: "paymentByLink",
                    defaultMessage: "الدفع من خلال اللينك الآتي",
                  })}
                </p>
                <div className="flex items-center justify-between gap-1">
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleSendPaymentUrl}
                  >
                    <span>{sendIconSVG}</span>
                  </Button>

                  <Button
                    type="default"
                    htmlType="button"
                    className="flex justify-between w-full gap-1 "
                    onClick={() => {
                      navigator.clipboard.writeText(paymentUrl);
                      message.success(
                        intl.formatMessage({
                          id: "linkCopied",
                          defaultMessage: "تم نسخ الرابط",
                        })
                      );
                    }}
                  >
                    <p className="text-sm truncate ">{paymentUrl}</p>
                    <span>{copyIconSVG}</span>
                  </Button>
                </div>
                <p className="text-sm text-gray-400 text-end">
                  <span> {infoSVG} </span>
                  <span>
                    {intl.formatMessage({
                      id: "sendPaymentLink",
                      defaultMessage:
                        " عند الضغط على ارسال، سيتم ارسال رابط الدفع الى العميل",
                    })}
                  </span>
                </p>
              </div>
            ) : null} */}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-2">
            {paymentMethods?.map((method: { id: number; name: string }) => {
              return (
                <Button
                  key={method?.id}
                  type="default"
                  htmlType="button"
                  className={
                    "  col-span-1  w-full flex justify-center items-center gap-1 " +
                    (paymentMethod === method?.id
                      ? "text-[#479821] border-[#479821]"
                      : "")
                  }
                  onClick={() => setPaymentMethod(method?.id)}
                >
                  {paymentMethod === method?.id ? (
                    <span className="mt-1">{selectedIconSVG}</span>
                  ) : null}
                  <span className="capitalize">{method.name}</span>
                </Button>
              );
            })}
          </div>
        )}
      </Spin>
    </div>
  );
};

export default PaymentMethod;
